(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    document.addEventListener('click', function (event) {
      const upsellLink = event.target.closest('.td-cart-upsell__button');
      if (!upsellLink) return;
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.close();
      window.location.href = upsellLink.getAttribute('href');
    });

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    const checkoutButton = document.querySelector('#checkout') || document.querySelector('#CartDrawer-Checkout');
    if (checkoutButton && !checkoutButton.closest('td-capture-health-checkout')) {
      checkoutButton.addEventListener('click', function (event) {
        const form = document.querySelector('#CartDrawer-Form') || document.querySelector('#cart');
        if (form) form.submit();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-capture-health-checkout"] && !Shopify.designMode) return;
  try {
    /**
   * @class TdCaptureHealthCheckout
   * Handles cart checkout submissions to Capture Health API.
   * Dispatches 'td-capture-health:open' on document for the modal to handle.
   */
  if (!customElements.get('td-capture-health-checkout')) {
    customElements.define('td-capture-health-checkout', class TdCaptureHealthCheckout extends HTMLElement {
      constructor() {
        super();

        this.submitButton = this.querySelector('.td-capture-health-checkout__button');
        this.errorMessageWrapper = this.querySelector('.td-capture-health-checkout__error-message-wrapper');
        this.errorMessage = this.querySelector('.td-capture-health-checkout__error-message');
        this.apiUrl = this.dataset.apiUrl?.trim();
        this.sectionId = this.dataset.section;
        this.shippingOptions = [];

        if (this.dataset.shippingOptions) {
          try {
            this.shippingOptions = JSON.parse(this.dataset.shippingOptions);
          } catch (error) {
            console.error('TD Capture Health: Failed to parse shipping options', error);
          }
        }
        
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        }
      }
      
      /**
       * Handle button click
       */
      async onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.disabled) {
          return;
        }
        
        /* Disable immediately to prevent double-submit during async cart fetch and prepareCheckoutData */
        this.setLoadingState(true);
        
        if (!this.apiUrl) {
          this.showError('Invalid configuration. Please contact support.');
          this.setLoadingState(false);
          return;
        }
        
        let cartData;
        try {
          const cartResponse = await fetch('/cart.js');
          cartData = await cartResponse.json();
          
          if (!cartData || !cartData.items || cartData.items.length === 0) {
            this.showError('Your cart is empty.');
            this.setLoadingState(false);
            return;
          }
        } catch (error) {
          this.showError('Failed to load cart data. Please try again.');
          this.setLoadingState(false);
          return;
        }
        
        let checkoutData;
        try {
          checkoutData = await this.prepareCheckoutData(cartData);
        } catch (error) {
          this.showError('Failed to prepare checkout data. Please try again.');
          this.setLoadingState(false);
          return;
        }
        
        const hasItems = checkoutData.items && checkoutData.items.length > 0;
        const hasBundles = checkoutData.bundles && checkoutData.bundles.length > 0;
        
        if (!hasItems && !hasBundles) {
          this.showError('Unable to process checkout. Please ensure all products are properly configured.');
          console.error('Checkout data missing items and bundles:', checkoutData);
          this.setLoadingState(false);
          return;
        }
        
        this.submitCheckout(checkoutData);
      }
      
      /**
       * Prepare checkout data in Capture Health format
       * Single product in JSON: treat as regular item, not bundle
       * Multiple products in JSON: handle as bundle
       * @param {Object} cartData - Cart data
       * @returns {Object} Checkout data
       */
      async prepareCheckoutData(cartData) {
        const items = [];
        const bundles = [];
        
        for (const cartItem of cartData.items) {
          const cartItemElement = document.querySelector(`[data-cart-item-key="${cartItem.key}"]`);
          
          if (!cartItemElement) {
            console.warn('Cart item element not found for item', cartItem.key);
            continue;
          }
          
          const captureHealthData = cartItemElement.getAttribute('data-capture-health-data') || 
                                            cartItemElement.dataset.captureHealthData;

          if (captureHealthData) {
            const bundledItems = this.parseBundledMedicationItems(captureHealthData);
            if (bundledItems && bundledItems.length === 1) {
              const checkoutItem = this.buildItemFromBundledData(cartItem, cartItemElement, bundledItems[0]);
              if (checkoutItem) {
                items.push(checkoutItem);
              }
            } else if (bundledItems && bundledItems.length > 1) {
              const bundle = this.buildBundle(cartItem, cartItemElement, bundledItems);
              if (bundle) {
                bundles.push(bundle);
              }
            }
          } else {
            console.warn('No capture health data found for cart item', cartItem.product_title);
          }
        }
        
        const shippingOptions = this.shippingOptions;
        const checkoutPayload = {
          frequency: 120, // TODO: Get frequency from cart item, future feature
          isSubscription: false // TODO: Get isSubscription from cart item, future feature
        };

        if (items.length > 0) checkoutPayload.items = items;
        if (bundles.length > 0) checkoutPayload.bundles = bundles;
        if (shippingOptions.length > 0) checkoutPayload.shippingOptions = shippingOptions;
        
        return checkoutPayload;
      }

      
      /**
       * Parse bundled medication JSON into normalized item array
       * @returns {Array<{offeringId: string, quantity: number}>|null}
       */
      parseBundledMedicationItems(bundleItemsJson) {
        if (!bundleItemsJson) return null;
        try {
          const parsed = JSON.parse(bundleItemsJson);
          if (!Array.isArray(parsed) || parsed.length === 0) return null;
          return parsed.map((item) => {
            if (typeof item === 'object' && item.dosageId) {
              return { offeringId: item.dosageId, quantity: item.quantity || 1 };
            }
            if (typeof item === 'string') {
              return { offeringId: item, quantity: 1 };
            }
            return null;
          }).filter(Boolean);
        } catch (error) {
          console.error('Failed to parse bundled medication items', error);
          return null;
        }
      }
      
      /**
       * Build item from single bundled medication (when JSON has only one product)
       * @param {Object} cartItem - Cart item
       * @param {Object} cartItemElement - Cart item element
       * @param {Object} bundledItem - Bundled item data
       * @returns {Object} Item data
       */
      buildItemFromBundledData(cartItem, cartItemElement, bundledItem) {
        const { offeringId, quantity: perUnitQuantity } = bundledItem;
        const quantityValue = perUnitQuantity * cartItem.quantity;
        
        const listPrice = cartItem.original_price / 100;
        const finalPrice = cartItem.final_price / 100;
        const discountAmount = cartItem.original_price > cartItem.final_price ? (cartItem.original_price - cartItem.final_price) / 100 : 0;
        
        const discounts = [];
        // TODO: Uncomment this when discounts are implemented
        // const discounts = this.extractDiscounts(cartItem, discountAmount);

        return {
          offeringId,
          quantity: quantityValue,
          pricing: {
            listPrice,
            finalPrice,
            discountAmount: discountAmount > 0 ? discountAmount : undefined
          },
          discounts: discounts.length > 0 ? discounts : undefined
        };
      }
      
      /**
       * Build bundle from kit cart item (multiple products in bundled medication JSON)
       * @param {Object} cartItem - Cart item
       * @param {Object} cartItemElement - Cart item element
       * @param {Array<Object>} bundledItems - Bundled items data
       * @returns {Object} Bundle data
       */
      buildBundle(cartItem, cartItemElement, bundledItems) {
        if (!bundledItems || bundledItems.length === 0) {
          console.warn('No bundled medication items found for kit', cartItem.handle || cartItem.product_id);
          return null;
        }
        
        const listPrice = cartItem.original_price / 100;
        const finalPrice = cartItem.final_price / 100;
        const bundleImage = cartItemElement.getAttribute('data-product-image') || 
                            cartItemElement.dataset.productImage;
        const description = cartItemElement.getAttribute('data-product-description') || 
                            cartItemElement.dataset.productDescription;

        return {
          id: `bundle-${cartItem.product_id}`,
          name: cartItem.product_title || 'Kit',
          description: description || '',
          imageUrl: bundleImage || '',
          items: bundledItems,
          pricing: {
            listPrice: listPrice,
            finalPrice: finalPrice
          }
        };
      }
      
      /**
       * Extract discounts from cart item
       * @param {Object} cartItem - Cart item
       * @param {number} discountAmount - Discount amount
       * @returns {Array<Object>} Discounts
       */
      extractDiscounts(cartItem, discountAmount) {
        const discounts = [];
        
        if (cartItem.discounts && cartItem.discounts.length > 0) {
          cartItem.discounts.forEach(discount => {
            discounts.push({
              type: discount.type || 'percentage',
              code: discount.code || '',
              description: discount.title || '',
              amount: (discount.amount || 0) / 100,
              appliedAmount: discountAmount || 0
            });
          });
        }
        
        return discounts;
      }
      
      /**
       * Submit checkout to Capture Health API
       * On success, dispatches 'td-capture-health:open' with the checkout URL
       * @param {Object} checkoutData - Checkout data
       */
      async submitCheckout(checkoutData) {
        try {
          this.setLoadingState(true);
          this.hideError();

          const response = await fetch(this.apiUrl, {
            method: 'POST',
            headers: {
              'Origin': `${window.location.origin}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(checkoutData)
          });
          
          const responseData = await response.json();
          
          if (response.ok) {
            const checkoutUrl = responseData.redirectUrl || responseData.redirect_url || responseData.url;
            if (checkoutUrl) {
              document.dispatchEvent(new CustomEvent('td-iframe-modal:open', {
                detail: { url: checkoutUrl, title: 'Complete Your Prescription' }
              }));
            } else {
              this.showError('Checkout URL not provided. Please contact support.');
            }
          } else {
            this.showError(`Checkout Error: ${response.status} - ${responseData.message || responseData.error || 'Unknown error'}`);
          }
        } catch (error) {
          console.error('Capture Health checkout error:', error);
          this.showError('Network error occurred. Please check your connection and try again.');
        } finally {
          this.setLoadingState(false);
        }
      }
      
      /**
       * Set loading state on button
       * @param {boolean} loading - Loading state
       */
      setLoadingState(loading) {
        if (this.submitButton) {
          if (loading) {
            this.submitButton.classList.add('loading');
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.disabled = true;
          } else {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;
          }
        }
      }
      
      /**
       * Show error message
       * @param {string} message - Error message
       */
      showError(message) {
        if (this.errorMessageWrapper && this.errorMessage) {
          this.errorMessage.textContent = message;
          this.errorMessageWrapper.hidden = false;
          
          setTimeout(() => {
            this.hideError();
          }, 5000);
        }
      }
      
      /**
       * Hide error message
       * @returns {void}
       */
      hideError() {
        if (this.errorMessageWrapper) {
          this.errorMessageWrapper.hidden = true;
        }
      }
      
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-iframe-modal"] && !Shopify.designMode) return;
  try {
    /**
   * @class TdIframeModal
   * Generic full-screen iframe modal.
   *
   * Listens for 'td-iframe-modal:open' on document.
   *   detail.url    {string} – required, the URL to load in the iframe
   *   detail.title  {string} – optional, sets the modal header text
   *
   * Dispatches 'td-iframe-modal:closed' on document when dismissed.
   */
  if (!customElements.get('td-iframe-modal')) {
    const KLAVIYO_CAPTURE_HEALTH_CHECKOUT_COMPLETED_EVENT = 'Capture Health Checkout Completed';

    customElements.define('td-iframe-modal', class TdIframeModal extends HTMLElement {
      constructor() {
        super();

        this.closeBtn = this.querySelector('.td-iframe-modal__close');
        this.titleEl = this.querySelector('.td-iframe-modal__title');
        this.iframe = this.querySelector('.td-iframe-modal__iframe');
        this.loader = this.querySelector('.td-iframe-modal__loader');
        this.allowedMessageOrigin = null;
        this.processedCheckoutKey = null;

        this.BOUND_KEYDOWN = this.onKeydown.bind(this);
        this.BOUND_OPEN = this.onOpenEvent.bind(this);
        this.BOUND_MESSAGE = this.onMessageEvent.bind(this);

        this.setupListeners();
      }

      setupListeners() {
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', this.close.bind(this));
        }
        document.addEventListener('td-iframe-modal:open', this.BOUND_OPEN);
        window.addEventListener('message', this.BOUND_MESSAGE);
      }

      /**
       * @param {CustomEvent} evt
       */
      onOpenEvent(evt) {
        const { url, title } = evt.detail || {};
        if (!url) {
          console.error('TD Iframe Modal: No URL provided in open event');
          return;
        }
        this.open(url, title);
      }

      /**
       * @param {string} url - URL to load in the iframe
       * @param {string} [title] - Optional header text
       */
      open(url, title) {
        if (!this.iframe) {
          console.error('TD Iframe Modal: iframe element not found');
          return;
        }

        try {
          this.allowedMessageOrigin = new URL(url, window.location.origin).origin;
        } catch (error) {
          this.allowedMessageOrigin = null;
          console.warn('TD Iframe Modal: Failed to parse iframe origin', error);
        }
        this.processedCheckoutKey = null;

        if (this.titleEl) {
          this.titleEl.textContent = title || '';
        }
        this.setAttribute('aria-label', title || '');

        this.iframe.classList.remove('td-iframe-modal__iframe--loaded');
        if (this.loader) this.loader.hidden = false;

        this.iframe.addEventListener('load', () => {
          this.iframe.classList.add('td-iframe-modal__iframe--loaded');
          if (this.loader) this.loader.hidden = true;
        }, { once: true });

        this.iframe.src = url;
        this.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.BOUND_KEYDOWN);

        this.closeBtn?.focus();
      }

      close() {
        this.hidden = true;
        if (this.iframe) {
          this.iframe.src = 'about:blank';
          this.iframe.classList.remove('td-iframe-modal__iframe--loaded');
        }
        this.allowedMessageOrigin = null;
        this.processedCheckoutKey = null;
        if (this.loader) this.loader.hidden = false;
        if (this.titleEl) this.titleEl.textContent = '';
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.BOUND_KEYDOWN);

        document.dispatchEvent(new CustomEvent('td-iframe-modal:closed'));
      }

      /**
       * @param {KeyboardEvent} evt
       */
      onKeydown(evt) {
        if (evt.key === 'Escape') {
          this.close();
        }
      }

      /**
       * @param {MessageEvent} event
       */
      async onMessageEvent(event) {
        if (this.hidden || !this.allowedMessageOrigin || event.origin !== this.allowedMessageOrigin) {
          return;
        }

        let payload = event.data;

        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (error) {
            return;
          }
        }

        if (!payload || payload.type !== 'CHECKOUT_COMPLETE' || !payload.success) {
          return;
        }

        const customer = payload.customer || {};
        const order = payload.order || {};
        const orderId = order.orderId;

        if (orderId && this.processedCheckoutKey === orderId) {
          return;
        }
        if (orderId) {
          this.processedCheckoutKey = orderId;
        }

        document.dispatchEvent(new CustomEvent('td-capture-health:checkout-complete', {
          detail: {
            customer,
            order,
            origin: event.origin
          }
        }));

        if (window.klaviyo && typeof window.klaviyo.identify === 'function' && customer.email) {
          try {
            await Promise.resolve(window.klaviyo.identify({
              email: customer.email,
              first_name: customer.firstName,
              last_name: customer.lastName,
              phone_number: customer.phone
            }));
          } catch (error) {
            console.error('TD Iframe Modal: Klaviyo identify failed', error);
          }
        }

        if (window.klaviyo && typeof window.klaviyo.track === 'function') {
          try {
            const klaviyoEventProperties = {
              amount: order.amount
            };

            if (orderId) {
              klaviyoEventProperties.order_id = orderId;
            }

            await Promise.resolve(window.klaviyo.track(
              KLAVIYO_CAPTURE_HEALTH_CHECKOUT_COMPLETED_EVENT,
              klaviyoEventProperties
            ));
          } catch (error) {
            console.error('TD Iframe Modal: Klaviyo track failed', error);
          }
        }
      }

      disconnectedCallback() {
        document.removeEventListener('td-iframe-modal:open', this.BOUND_OPEN);
        document.removeEventListener('keydown', this.BOUND_KEYDOWN);
        window.removeEventListener('message', this.BOUND_MESSAGE);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-kit-upsell-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-kit-upsell-drawer')) {
    class TDKitUpsellDrawer extends HTMLElement {
      constructor() {
        super();
        this.overlay = this.querySelector('.td-kit-upsell-drawer__overlay');
        this.closeButton = this.querySelector('.td-kit-upsell-drawer__close');
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.addToCartButton = this.querySelector('[data-add-to-cart]');

        this.setupEventListeners();
      }

      setupEventListeners() {
        document.addEventListener('open-product-drawer', this.handleOpenProductDrawer.bind(this));
        
        // Close button click
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }
        
        // Overlay click
        if (this.overlay) {
          this.overlay.addEventListener('click', this.handleOverlayClick.bind(this));
        }
        
        // Prevent clicks inside drawer inner from closing
        this.inner = this.querySelector('.td-kit-upsell-drawer__inner');
        if (this.inner) {
          this.inner.addEventListener('click', (e) => e.stopPropagation());
        }

        // Add to cart button
        if (this.addToCartButton) {
          this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
        }
        
        // Escape key handler
        this.handleKeyDown = this.handleKeyDown.bind(this);
      }

      handleOpenProductDrawer(event) {
        const targetProductId = event.detail.productId;
        if (targetProductId !== this.productId) {
          return;
        }
        
        this.open();
      }
      
      handleOverlayClick(event) {
        // Only close if clicking directly on the overlay, not on child elements
        if (event.target === this.overlay) {
          this.close();
        }
      }

      handleAddToCart(event) {
        if (!this.variantId) {
          console.error('No variant ID available');
          return;
        }

        if (this.addToCartButton.getAttribute('aria-disabled') === 'true') return;

        // Disable button and show loading state
        this.addToCartButton.setAttribute('aria-disabled', 'true');
        this.addToCartButton.classList.add('loading');
        const originalHTML = this.addToCartButton.innerHTML;

        // Prepare form data
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);

        // Get cart drawer/notification if available
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && cart.getSectionsToRender) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }
        }

        // Fetch config
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        // Add to cart
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error adding to cart
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'td-kit-upsell-drawer',
                  productVariantId: this.variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              console.error('Error adding to cart:', response.description);
              this.addToCartButton.innerHTML = originalHTML;
              this.addToCartButton.removeAttribute('aria-disabled');
              this.addToCartButton.classList.remove('loading');
              this.error = true;
              return;
            }

            // Success
            this.error = false;

            // If no cart drawer/notification, redirect to cart page
            if (!cart) {
              window.location = routes.cart_url;
              return;
            }

            // Update cart drawer/notification
            if (cart.renderContents) {
              cart.renderContents(response);
            }

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'td-kit-upsell-drawer',
                productVariantId: this.variantId,
                cartData: response,
              });
            }

            // Close drawer after successful add to cart
            setTimeout(() => {
              this.close();
            }, 500);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            this.addToCartButton.innerHTML = originalHTML;
            this.addToCartButton.removeAttribute('aria-disabled');
            this.addToCartButton.classList.remove('loading');
            this.error = true;
          })
          .finally(() => {
            this.addToCartButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.addToCartButton.removeAttribute('aria-disabled');
            }
          });
      }
      
      open() {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        
        // Add escape key listener when drawer opens
        document.addEventListener('keydown', this.handleKeyDown);
        
        // Trap focus
        setTimeout(() => {
          if (typeof trapFocus !== 'undefined') {
            trapFocus(this, this.closeButton);
          }
        }, 100);
      }
      
      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        
        // Remove escape key listener when drawer closes
        document.removeEventListener('keydown', this.handleKeyDown);
        
        if (typeof removeTrapFocus !== 'undefined') {
          removeTrapFocus();
        }
      }
      
      handleKeyDown(event) {
        if (event.code === 'Escape' && this.classList.contains('active')) {
          this.close();
        }
      }
    }
    
    customElements.define('td-kit-upsell-drawer', TDKitUpsellDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-treatment-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-treatment-drawer')) {
  class TreatmentDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
      this.boundHandleTreatmentClick = null;
      this.boundClose = null;
      this.boundHandleKeyup = null;
    }

    connectedCallback() {
      this.sectionId = this.id ? this.id.replace('td-treatment-drawer-', '') : '';
      
      // DOM elements
      this.overlay = this.querySelector('.td-treatment-drawer__overlay');
      this.inner = this.querySelector('.td-treatment-drawer__inner');
      this.closeButton = this.querySelector('.td-treatment-drawer__close');
      this.titleEl = this.querySelector('.td-treatment-drawer__title');
      this.kitsContainer = this.querySelector('.td-treatment-drawer__kits');
      this.weekenderBadge = this.querySelector('.td-treatment-drawer__kit-badge--weekender');
      this.descriptionEl = this.querySelector('.td-treatment-drawer__description');
      this.medicationsContainer = this.querySelector('.td-treatment-drawer__medications');
      this.symptomsHeadingEl = this.querySelector('.td-treatment-drawer__symptoms-heading');
      this.symptomsListEl = this.querySelector('.td-treatment-drawer__symptoms-list');
      this.calloutHeadingEl = this.querySelector('.td-treatment-drawer__callout-heading');
      this.calloutContentEl = this.querySelector('.td-treatment-drawer__callout-content');
      
      this.setupListeners();
    }

    disconnectedCallback() {
      if (this.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.activeElement);
        }
      }
      
      this.removeListeners();
    }
    
    setupListeners() {
      this.boundHandleTreatmentClick = this.handleTreatmentClick.bind(this);
      this.boundClose = this.close.bind(this);
      this.boundHandleKeyup = (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      };
      this.boundHandleLinkClick = this.handleLinkClick.bind(this);

      document.addEventListener('treatment-item-click', this.boundHandleTreatmentClick);
      
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.boundClose);
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.boundClose);
      }
      this.addEventListener('keyup', this.boundHandleKeyup);
      
      /* Close drawer when clicking links inside the drawer content */
      if (this.inner) {
        this.inner.addEventListener('click', this.boundHandleLinkClick);
      }
    }

    removeListeners() {
      if (this.boundHandleTreatmentClick) {
        document.removeEventListener('treatment-item-click', this.boundHandleTreatmentClick);
      }
      if (this.closeButton && this.boundClose) {
        this.closeButton.removeEventListener('click', this.boundClose);
      }
      if (this.overlay && this.boundClose) {
        this.overlay.removeEventListener('click', this.boundClose);
      }
      if (this.boundHandleKeyup) {
        this.removeEventListener('keyup', this.boundHandleKeyup);
      }
      if (this.inner && this.boundHandleLinkClick) {
        this.inner.removeEventListener('click', this.boundHandleLinkClick);
      }
    }

    /**
     * Handle clicks on links inside the drawer content
     * Closes the drawer when any link is clicked
     */
    handleLinkClick(event) {
      const link = event.target.closest('a');
      if (link) {
        this.close();
      }
    }

    parseJsonAttribute(value) {
      if (!value || value === '' || value === '[]') {
          return value === '[]' ? [] : '';
        }
        if (typeof value === 'string' && (value.trim().startsWith('[') || value.trim().startsWith('{'))) {
          try {
            return JSON.parse(value);
          } catch (e) {
            return value;
          }
        }
      return value;
    }

    handleTreatmentClick(event) {
      const { sectionId, treatmentData } = event.detail;
      
      // Only respond to clicks from this drawer's associated section
      if (sectionId !== this.sectionId) return;
      
      this.populateDrawer(treatmentData);
      this.open();
    }
    
    populateDrawer(data) {
      if (this.titleEl) {
        this.titleEl.textContent = data.title;
      }

      if (this.kitsContainer) {
        this.kitsContainer.innerHTML = '';
        const approvedKits = this.parseJsonAttribute(data.approvedKits);
        const failingKits = this.parseJsonAttribute(data.failingKits);

        if (Array.isArray(approvedKits) && approvedKits.length > 0) {
          approvedKits.forEach(kit => {
            const kitItem = document.createElement('div');
            kitItem.className = 'td-treatment-drawer__kit-badge td-treatment-drawer__kit-badge--treats';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__kit-icon';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#004422"/><path d="M5.8335 10.4167L8.3335 13.3333L13.3335 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            
            const text = document.createElement('span');
            text.className = 'td-treatment-drawer__kit-text';
            text.textContent = kit;
            
            kitItem.appendChild(icon);
            kitItem.appendChild(text);
            this.kitsContainer.appendChild(kitItem);
          });
        }

        if (Array.isArray(failingKits) && failingKits.length > 0) {
          failingKits.forEach(kit => {
            const kitItem = document.createElement('div');
            kitItem.className = 'td-treatment-drawer__kit-badge td-treatment-drawer__kit-badge--doesnt-treat';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__kit-icon td-treatment-drawer__kit-icon--close';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 1.2583L6.78151 7" stroke="#969189" stroke-width="2" stroke-linecap="round"/><path d="M1.26904 7L6.51904 1" stroke="#969189" stroke-width="2" stroke-linecap="round"/></svg>';
            
            const text = document.createElement('span');
            text.className = 'td-treatment-drawer__kit-text';
            text.textContent = kit;
            
            kitItem.appendChild(icon);
            kitItem.appendChild(text);
            this.kitsContainer.appendChild(kitItem);
          });
        }
      }

      if (this.descriptionEl) {
        this.descriptionEl.innerHTML = data.description;
      }

      if (this.medicationsContainer) {
        this.medicationsContainer.innerHTML = '';
        const medications = this.parseJsonAttribute(data.medications);

        if (Array.isArray(medications) && medications.length > 0) {
          medications.forEach(medication => {
            const medicationItem = document.createElement('div');
            medicationItem.className = 'td-treatment-drawer__medication-pill';
            medicationItem.textContent = medication;
            this.medicationsContainer.appendChild(medicationItem);
          });
        }
      }

      if (this.symptomsHeadingEl) {
        this.symptomsHeadingEl.textContent = data.heading;
      }
      
      if (this.symptomsListEl) {
        this.symptomsListEl.innerHTML = '';
        const symptoms = this.parseJsonAttribute(data.symptoms);

        if (Array.isArray(symptoms) && symptoms.length > 0) {
          symptoms.forEach(symptom => {
            const symptomItem = document.createElement('div');
            symptomItem.className = 'td-treatment-drawer__symptom-item';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__symptom-icon';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#004422"/><path d="M5.8335 10.4167L8.3335 13.3333L13.3335 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            
            const text = document.createTextNode(symptom);
            
            symptomItem.appendChild(icon);
            symptomItem.appendChild(text);
            this.symptomsListEl.appendChild(symptomItem);
          });
        }
      }
      
      if (this.calloutHeadingEl) {
        this.calloutHeadingEl.textContent = data.calloutHeading;
      }
      
      if (this.calloutContentEl) {
        this.calloutContentEl.innerHTML = data.calloutContent;
      }
    }
    
    /**
     * Open the drawer
     */
    open() {
      this.activeElement = document.activeElement;
      
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');

      const focusElement = this.querySelector('.td-treatment-drawer__close') || this.querySelector('.td-treatment-drawer__inner');
      if (typeof trapFocus === 'function') {
        trapFocus(this.querySelector('.td-treatment-drawer__inner'), focusElement);
      }
    }
    
    /**
     * Close the drawer
     */
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
      // Remove focus trap and restore focus to triggering element
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
      
      this.activeElement = null;
    }
  }
  
  customElements.define('td-treatment-drawer', TreatmentDrawer);
}
  } catch(e) { console.error(e); }
})();

})();
